var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditIconNew(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.728 3.23771C12.3489 2.56491 12.6594 2.2285 12.9894 2.03228C13.7855 1.5588 14.7658 1.54408 15.5752 1.99344C15.9106 2.17967 16.2307 2.5066 16.8707 3.16047C17.5108 3.81434 17.8309 4.14127 18.0132 4.48394C18.453 5.31077 18.4386 6.31216 17.9751 7.12542C17.7831 7.46247 17.4537 7.77965 16.7951 8.41401L8.95872 15.9618C7.7106 17.1639 7.08653 17.765 6.30659 18.0696C5.52664 18.3743 4.6692 18.3518 2.95434 18.307L2.72102 18.3009C2.19896 18.2872 1.93793 18.2804 1.78619 18.1082C1.63445 17.936 1.65517 17.6701 1.6966 17.1383L1.7191 16.8496C1.83571 15.3528 1.89401 14.6044 2.18629 13.9317C2.47857 13.259 2.98273 12.7127 3.99106 11.6203L11.728 3.23771Z",
    stroke: "#3348FF",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8332 3.33301L16.6665 9.16634",
    stroke: "#3348FF",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6665 18.333L18.3332 18.333",
    stroke: "#3348FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIconNew);
export default __webpack_public_path__ + "static/media/edit-icon-new.acefdbedac425cdeea8b0e49edb847e6.svg";
export { ForwardRef as ReactComponent };